module.exports = __webpack_public_path__ + "static/img/money_1.8af864e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/money_1.svg
// module id = ldNx
// module chunks = 1